import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Link } from 'react-router-dom';

export default function CheckoutSteps(props) {
  const steps = [
    { name: 'Shipping', link: '/shipping', active: props.step2 },
    { name: 'Place Order', link: '/placeorder', active: props.step3 },
    { name: 'Confirmed', link: null, active: props.step4 },
  ];

  return (
    <Row className="checkout-steps mb-5 g-0">
      {steps.map((step, index) => {
        // A step is clickable if it has a link and it's an active step but NOT the current one
        // More specifically, if the NEXT step is also active, then this one is definitely a previous step.
        const isPreviousStep = index < steps.length - 1 && steps[index + 1].active;
        const isClickable = step.link && isPreviousStep;

        return (
          <Col key={index} className={step.active ? 'active' : ''}>
            <div className="step-label">
              {isClickable ? (
                <Link to={step.link}>{step.name}</Link>
              ) : (
                <span>{step.name}</span>
              )}
            </div>
            <div className="step-bar"></div>
          </Col>
        );
      })}
    </Row>
  );
}
